module.exports = __webpack_public_path__ + "Ciara Sun-400b5368.png";